




















































































































































import { Component, Vue, Ref } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { UserData } from '../models/user';
import {
  SignUpValidationErrors,
  SignUpErrors,
} from '../store/modules/signup/types';

@Component({
  name: 'SignUp',
})
export default class SignUp extends Vue {
  @Ref() readonly signUpForm!: HTMLFormElement;

  @Action('signup/createAccount') createAccount!: (
    invitation: string
  ) => Promise<UserData | SignUpErrors>;

  @Getter('signup/getName') getName!: () => string;
  @Getter('signup/getEmail') getEmail!: () => string;
  @Getter('signup/getPhone') getPhone!: () => string;
  @Getter('signup/getOrganization') getOrganization!: () => string;
  @Getter('signup/getBusinessType') getBusinessType!: () => string;
  @Getter('signup/errors') errors!: () => SignUpValidationErrors;
  @Getter('org/getName') getOrgName!: () => string;

  @Mutation('signup/setName') setName!: (name: string) => void;
  @Mutation('signup/setEmail') setEmail!: (name: string) => void;
  @Mutation('signup/setPhone') setPhone!: (name: string) => void;
  @Mutation('signup/setOrganization') setOrganization!: (name: string) => void;
  @Mutation('signup/setBusinessType') setBusinessType!: (name: string) => void;

  errorMessage = '';
  formValidity = false;
  submiting = false;
  termsDialog = false;
  privacyDialog = false;
  contentDialog = false;
  success = false;

  isEmailDisabled() {
    if ((this.$route.query.email as string) != undefined) {
      return true;
    }

    return false;
  }

  created() {
    if (this.$route.query.email != undefined) {
      this.setEmail(this.$route.query.email as string);
    }
  }

  register() {
    if (!this.formValidity) {
      this.signUpForm.validate();
      return;
    }

    this.submiting = true;

    let invitation = '';
    if (this.$route.query.invitation != undefined) {
      invitation = this.$route.query.invitation as string;
    }

    this.createAccount(invitation)
      .then(() => {
        this.submiting = false;
        this.success = true;
      })
      .catch((error: SignUpErrors) => {
        this.submiting = false;
        this.errorMessage = error.message;

        if (error.errors) {
          this.errorMessage += error.errors.map(
            err => `<li>${err.message}</li>`
          );
          this.errorMessage = this.errorMessage.replace(',', '');
        }
      });
  }
}
